import classNames from 'classnames';
import { capitalize, isArray } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import RightArrowIcon from '../icons/RightArrowIcon.jsx';
import SubHeader from '../SubHeader.jsx';
import CategoriesTable from './CategoriesTable.jsx';
import styles from './CategoriesSection.module.css';

const CategoriesSection = ({ type, initiativeCategories, onShowModal }) => {
  const [categoriesHidden, setCategoriesHidden] = useState(true);

  const toggleInitiatives = useCallback((e) => {
    e.preventDefault();
    setCategoriesHidden((hidden) => !hidden);
  }, []);

  const tableContainerId = `${type}InitiativesTableContainer`;
  const typeCapitalized = capitalize(type);

  const className = classNames(
    styles.initiativesTypeSection,
    styles.categoriesSection,
    {
      [styles.initiativesTypeHidden]: categoriesHidden,
    }
  );

  return (
    <section className={className}>
      <SubHeader flexJustify small>
        <div className={styles.categoriesHeading}>
          <div className="flex row" style={{ paddingLeft: '74px' }}>
            <h2 className="m-r-18">
              <a
                aria-controls={tableContainerId}
                aria-expanded={!categoriesHidden}
                className="flex"
                href="#"
                onClick={toggleInitiatives}
                role="button"
              >
                <RightArrowIcon className="collapse-caret-inside" />
                <span className={styles.initiativeType}>{typeCapitalized}</span>
              </a>
            </h2>
            <strong className="bordered text-muted">
              Total:&nbsp;
              <span className="text-info-brand count">
                {initiativeCategories.length}
              </span>
            </strong>
          </div>
        </div>
      </SubHeader>
      <div id={tableContainerId}>
        {!categoriesHidden && isArray(initiativeCategories) && (
          <CategoriesTable
            initiativeCategories={initiativeCategories}
            initiativeType={type}
            onShowModal={onShowModal}
          />
        )}
      </div>
    </section>
  );
};

CategoriesSection.propTypes = {
  type: PropTypes.string.isRequired,
};

export default CategoriesSection;
